module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b0vmE"))).then(() => parcelRequire('hEqeo'));